import { render } from "./PermitHeadingInfo.vue?vue&type=template&id=5501521c"
import script from "./PermitHeadingInfo.vue?vue&type=script&lang=ts"
export * from "./PermitHeadingInfo.vue?vue&type=script&lang=ts"
script.render = render

export default script